import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SyncStatus {
  loading: boolean;
}

const initialState: SyncStatus = {
  loading: false,
};

const syncSlice = createSlice({
  name: "sync",
  initialState,
  reducers: {
    toggleSyncLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => {
      return initialState;
    });
  },
});

export const { toggleSyncLoading } = syncSlice.actions;
export default syncSlice.reducer;
